import { useEffect, useState } from 'react';
import { Observable, Observer } from 'windowed-observable';

export type ObservableData<T = any> = {
  data?: T;
  events: T[];
  previousEvent?: T;
};

export const useObservable = <T>(
  observable: Observable<T>,
  initialData?: T
) => {
  const [data, setData] = useState<ObservableData<T>>(() => {
    const lastEvent = observable.getLastEvent();

    return {
      data: lastEvent ?? initialData,
      events: lastEvent ? observable.getEvents() : [],
      previousEvent: lastEvent,
    };
  });

  useEffect(() => {
    const observer: Observer<T> = (newData, { events, lastEvent }) => {
      setData({ data: newData, events, previousEvent: lastEvent });
    };

    observable.subscribe(observer);

    return () => observable.unsubscribe(observer);
  }, [observable]);

  return data;
};
